<router-outlet></router-outlet>

<mat-drawer-container
  class="side-nav-drawer"
  [hasBackdrop]="true"
  disableClose
>
  <mat-drawer #drawer mode="push" position="end" disableClose [opened]="(isOpen$ | async)">
    <router-outlet name="sidenav"></router-outlet>
  </mat-drawer>
</mat-drawer-container>

<input type="hidden" name="packageVersion" [value]="packageVersion" />

<pl-user-idle> </pl-user-idle>
